import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  on: {
    color: theme.palette.green_200.main,
    fontSize: '20px'
  },
  off: {
    color: theme.palette.red_100.main,
    fontSize: '20px'
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px'
  },
  statusDotOnline: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: theme.palette.green_200.main,
    display: 'inline-block'
  },
  statusDotOffline: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: theme.palette.red_100.main,
    display: 'inline-block'
  },
  statusText: {
    fontSize: '12px',
    fontWeight: '500'
  },
  pointer: {
    cursor: 'pointer'
  },
  tableHead: {
    backgroundColor: theme.palette.blue_300.main,
    '& tr th': {
      color: theme.palette.white_100.main,
      padding: '6px 8px',
      fontWeight: '600',
      borderBottom: 'none'
    }
  },
  tableRowEven: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.blue_50.main,
    '& td': {
      padding: '6px 8px',
      borderBottom: 'none', 
      borderTop: 'none'
    }
  },
  tableRowOdd: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    '& td': {
      padding: '6px 8px',
      borderBottom: 'none',
      borderTop: 'none' 
    }
  },
  tableCell: {
    padding: '6px 8px',
    borderBottom: 'none',
    borderTop: 'none' 
  },
  table: {
    '& .MuiTableCell-root': {
      borderBottom: 'none'
    }
  }
}))